<template>
    <div style="margin-top: 80px;">
        <div class="container">
            <p>{{ $t('aboutHead') }}</p>
            <h2 style="line-height: 33px;">{{ $t('aboutUSHeadline') }}</h2>
        </div>
        <img src="/img/about/main.png" alt="main" class="head-img">
        <div class="container">
            <p style="font-size: 14px;">{{ $t('aboutUSDescription') }}</p>
            <p style="font-size: 14px;">{{ $t('aboutUSTraining') }}</p>
        </div>
        <div class="bg-linear">
            <div class="container">
                <h2>{{ $t('vision') }}</h2>
                <h4>{{ $t('aboutUSVision') }}</h4>
                <h2 class="mt-7">{{ $t('mission') }}</h2>
                <div v-for="i in $t('aboutUSMission')" :key="i" class="benefit-list">
                    <div>
                        <complete fill="#162CA2" />
                    </div>
                    <p style="margin: 2px; font-size: 15px;">{{ i }}</p>
                </div>
                <h2 class="mt-7">{{ $t('values') }}</h2>
                <div class="card-hicol" v-for="(item, idx) in $t('aboutUSValue')" :key="idx">
                    <div>
                        <img :src="item.img" width="50" alt="Ctn" />
                    </div>
                    <div>
                        <p>{{ item.desc }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div style="margin-top: 80px;">
                <img src="/img/about/m1.png" width="100%" alt="main">
                <h2>{{ $t('impact') }}</h2>
                <div v-for="(item, idx) in $t('aboutUSImpact')" :key="idx" class="benefit-list">
                    <div>
                        <complete fill="#162CA2" />
                    </div>
                    <p style="margin: 2px; font-size: 15px;" v-html="item"></p>
                </div>
            </div>
            <div style="margin-top: 80px;">
                <img src="/img/about/m2.png" width="100%" alt="main">
                <h2>{{ $t('culture') }}</h2>
                <div class="card-hicol" v-for="(item, idx) in $t('aboutUSCulture')" :key="idx">
                    <div>
                        <img :src="item.img" width="50" alt="Ctn" />
                    </div>
                    <div>
                        <h3 class="mb-3">{{ item.title }}</h3>
                        <p>{{ item.desc }}</p>
                    </div>
                </div>
            </div>
            <div style="margin-top: 50px;">
                <h2>{{ $t('achievement') }}</h2>
                <p style="font-size: 14px; margin-top: -20px;">{{ $t('aboutUSAchievement') }}</p>
                <img src="/img/about/m3.png" width="100%" alt="main" class="mb-4">
                <div v-for="(item, idx) in $t('aboutUSAchievementsList')" :key="idx" class="benefit-list">
                    <div>
                        <complete fill="#162CA2" />
                    </div>
                    <p style="margin: 2px; font-size: 15px;" v-html="item"></p>
                </div>
            </div>
            <!-- <div style="margin-top: 80px;"> -->
                <!-- <h2>{{ $t('aboutUSFounder') }}</h2> -->
                <!-- <div class="box-parent-owner">
                    <div class="box-owner">
                        <img src="/img/about/martha.png" style="width: 150px;" alt="Martha">
                        <p class="title">Martha Sutopo</p>
                        <p class="mb-4">{{ $t('aboutUSFounderRoleCEO') }}</p>
                        <img src="/img/about/linkedin.png" class="cursor-pointer" @click="directTo('martha')" alt="link">
                    </div>
                    <div class="box-owner">
                        <img src="/img/about/gilang.png" style="width: 150px;" alt="gilang">
                        <p class="title">Gilang Yudha Prakoso</p>
                        <p class="mb-4">{{ $t('aboutUSFounderRoleCCO') }}</p>
                        <img src="/img/about/linkedin.png" class="cursor-pointer" @click="directTo('gilang')" alt="link">
                    </div>
                </div> -->
            <!-- </div> -->
            <!-- <h3 style="margin-top: 50px; margin-bottom: 10px;">{{ $t('aboutUSTeam') }}</h3>
            <p>{{ $t('aboutUSTeamDescription') }}</p>
            <h3 style="margin-top: 60px; margin-bottom: 20px;">{{ $t('aboutUSOrgChart') }}</h3>
            <img src="/img/about/hirarki.png" alt="hirarki" style="width: 100%;"> -->
        </div>
        
        <div style="height: 90px;"></div>
        <div class="footer-head">
            <p><b style="font-weight: bold !important;">#MulaiLangkahHebat</b> {{ $t('aboutUSFinalCTA') }}</p>
            <v-btn depressed color="#FFDE59" class="button-daftar" @click="directTo">
                <span class="text-capitalize font-weight-bold font-poppins">{{ $t('aboutUSContactUs') }}</span>
            </v-btn>
        </div>
    </div>
</template>

<script>
import Complete from "@/assets/icons/Complete.vue";

export default {
    name: "MobileAboutUs",
    components: {
        Complete
    },
    data() {
        return {
        }
    },
    methods: {
        directTo(ctn) {
            if (ctn === "martha") {
                this.$gtag.event('click', {
                    event_category: 'Social Media',
                    event_label: 'LinkedIn - Martha Sutopo',
                    value: 1,
                });
                window.open('https://www.linkedin.com/in/martha-sutopo-47339475/', '_blank');
            } else if (ctn === "gilang") {
                this.$gtag.event('click', {
                    event_category: 'Social Media',
                    event_label: 'LinkedIn - Gilang Yudha Prakoso',
                    value: 1,
                });
                window.open('https://www.linkedin.com/in/gilang-yudha-prakoso-880302110/', '_blank');
            } else {
                this.$gtag.event('click', {
                    event_category: 'Button',
                    event_label: 'Contact Us WhatsApp',
                    value: 1,
                });
                window.open("https://api.whatsapp.com/send/?phone=6282127274632&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya", '_blank');
            }
        },
        getImage(key) {
            return `/img/icons/${key.toLowerCase()}.png`;
        },
    }
}
</script>

<style src="./aboutUs.css" scoped></style>
